var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SellHeader',{attrs:{"img_header":_vm.header_image,"header":"เมนูคำสั่งซื้อ","link_back":"sell/all"}}),_c('MenuSell'),_c('Order_partner_main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }